import { Instance } from 'mobx-state-tree'
import { UserGameScheduleResponseModelBase } from './UserGameScheduleResponseModel.base'

/* The TypeScript type of an instance of UserGameScheduleResponseModel */
export interface UserGameScheduleResponseModelType extends Instance<typeof UserGameScheduleResponseModel.Type> {}

/* A graphql query fragment builders for UserGameScheduleResponseModel */
export {
  selectFromUserGameScheduleResponse,
  userGameScheduleResponseModelPrimitives,
  UserGameScheduleResponseModelSelector
} from './UserGameScheduleResponseModel.base'

/**
 * UserGameScheduleResponseModel
 */
export const UserGameScheduleResponseModel = UserGameScheduleResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
